import React, { useState, useEffect, useRef } from "react";
import {
  Layout,
  ConfigProvider,
  Input,
  Row,
  Typography,
  Col,
  Card,
  Table,
  Spin,
  Select,
  Button,
} from "antd";
import { useNavigate } from "react-router-dom";
import { CSVLink } from "react-csv";
import MainLayout from "../../../../components/layouts/MainLayout";
import definedApi from "../../../../services/definedApi";
import { BOM } from "../../../../services/definedMethod";
import cnt from "../../../../services/definedConstant";
import { connect, useDispatch } from "react-redux";
import TopContent from "../../../../components/layouts/TopContent";
import appStatic from "../../../../config/appStatic";
import StatusSelect from "../../../../components/StatusSelect";
import appLabel from "../../../../config/appLabel";

import getGlListAction, {
  onSelectItemAction,
  rightAction,
} from "../../../../redux/actions";
import DownloadTableButtons from "../../../../components/DownloadTableButtons";

//global distructures
const { Text, Link, Title } = Typography;
const Search = Input;
const { FXRateSetupItems, monthList } = appStatic;

const columns = [
  {
    title: "Rate Date",
    dataIndex: "date",
    sorter: (a, b) => a.date.localeCompare(b.date),
  },
  {
    title: "FromCurrency",
    dataIndex: "fromCurrency",
    sorter: (a, b) => a.fromCurrency.localeCompare(b.fromCurrency),
  },
  {
    title: "To Currency",
    dataIndex: "toCurrency",
    sorter: (a, b) => a.toCurrency.localeCompare(b.toCurrency),
  },
  {
    title: "Rate Type",
    dataIndex: "rateType",
  },

  {
    title: "Conversion Currency",
    dataIndex: "conversionCurrency",
  },

  {
    title: "Status",
    dataIndex: "status",
    render: (text) => (
      <Text strong style={{ color: text ? "green" : "red" }}>
        {text ? "Active" : "Inactive"}
      </Text>
    ),
  },
];

const PRD0602 = (props) => {
  const navigate = useNavigate();

  //DECLARED VARIABLES
  const { userData, rightBtn, rightAction } = props;
  const { session } = userData;
  const [rateSetupList, setRateSetupList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [originalList, setOriginalList] = useState([]);
  const [tableCount, setTableCount] = useState("10");
  const [selectedRow, setSelectedRow] = useState(null);
  const [rightViewBtn, setRightViewBtn] = useState("default");
  const dispatch = useDispatch();

  //DECLARED METHODS

  useEffect(() => {
    BOM.HasPermission("READ_FX_RATE") && getRateSetupListAction();
    BOM.HasPermission("CREATE_FX_RATE") && rightAction(cnt.RIGHT_ADD_BTN);
  }, []);

  const getRateSetupListAction = () => {
    let body = {
      session,
    };

    BOM.FetchReqAction(body, definedApi.GetRateSetupList, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res;
        let tempArray = [];

        objList.forEach((element) => {
          tempArray.push({
            key: element?.id,
            date: element?.date
              ? `${element?.date[2]} ${monthList[element?.date[1] - 1]} ${
                  element?.date[0]
                }`
              : "-",
            fromCurrency: element?.fromCurrencyData
              ? element?.fromCurrencyData.displayLabel
              : "-",
            toCurrency: element?.toCurrencyData
              ? element?.toCurrencyData.displayLabel
              : "-",
            rateType: element?.rateType ? element?.rateType : "-",
            conversionCurrency: element?.conversionCurrencyData
              ? element?.conversionCurrencyData.displayLabel
              : "-",
            status: element.active,
          });
        });

        //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        // setRateSetupList(tempArray.filter((item) => item.disabled === false));
        setRateSetupList(tempArray);

        //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const getCsvListData = () => {
    return new Promise((resolve, reject) => {
      const params = {
        limit: 1000,
        offset: 0,
      };

      let body = {
        session,
        params,
      };

      BOM.FetchReqAction(body, definedApi.GetRateSetupList, (err, res) => {
        if (err) {
          reject(err);
        } else {
          const objList = res;
          let tempArray = [];

          objList.forEach((element) => {
            tempArray.push({
              key: element?.id,
              date: element?.date
                ? `${element?.date[2]} ${monthList[element?.date[1] - 1]} ${
                    element?.date[0]
                  }`
                : "-",
              fromCurrency: element?.fromCurrencyData
                ? element?.fromCurrencyData.displayLabel
                : "-",
              toCurrency: element?.toCurrencyData
                ? element?.toCurrencyData.displayLabel
                : "-",
              rateType: element?.rateType ? element?.rateType : "-",
              conversionCurrency: element?.conversionCurrencyData
                ? element?.conversionCurrencyData.displayLabel
                : "-",
              status: element.active ? "Active" : "Inactive",
            });
          });

          resolve(tempArray);
        }
      });
    });
  };

  //DECLARED METHODS
  const onSelectItemAction = (selectedRowKeys, objParam) => {
    //HOLD THE OBJECT SELECTED HERE
    setSelectedRow(objParam[0]);
    [
      BOM.HasPermission("READ_FX_RATE") && cnt.RIGHT_DETAIL_BTN,
      BOM.HasPermission("UPDATE_FX_RATE") && cnt.RIGHT_EDIT_BTN,
    ].map((item) => {
      dispatch({
        type: item,
      });
    });
  };

  function handleSearchInTable(searchKey) {
    searchKey = searchKey.target.value;

    if (!searchKey) {
      setRateSetupList(originalList);
      return;
    }
    const filterBySearch = originalList.filter(
      (item) =>
        item?.key === parseInt(searchKey) ||
        item?.fromCurrency.toLowerCase()?.includes(searchKey) ||
        item?.toCurrency.toLowerCase()?.includes(searchKey)
    );
    setRateSetupList(filterBySearch);
  }

  function selectTableCount(value) {
    setTableCount(value);
  }

  function handleOnView() {
    // console.log(selectedRow);
    const { detailBtn } = rightBtn;
    if (detailBtn.toLowerCase() === "primary") {
      navigate("/view-prd0602", { state: selectedRow });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  function handleOnCreate() {
    const { addBtn } = rightBtn;
    if (addBtn.toLowerCase() === "primary") {
      navigate("/add-prd0602", { ofObj: selectedRow });
    } else {
      console.log("Could not open the link");
    }
  }

  function handleOnEdit() {
    // console.log(selectedRow);
    const { editBtn } = rightBtn;
    if (editBtn.toLowerCase() === "primary") {
      navigate("/edit-prd0602", { state: selectedRow });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  return (
    <MainLayout
      isEnableRightSidebar={true}
      onView={handleOnView}
      onAdd={handleOnCreate}
      onEdit={handleOnEdit}
    >
      <TopContent
        pageTitle={appLabel.fxRateSetup}
        pageItems={FXRateSetupItems}
      />

      {/* RENDER TABLE LIST */}
      <Card
        title={"FX Rate Setup List"}
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        <Spin spinning={isLoading} size="large">
          <Row style={{ marginBottom: 20 }}>
            <div style={{ marginBottom: "auto" }}>
              <Text>Show</Text>
              <Select
                defaultValue={tableCount}
                options={[
                  { value: "5", label: "5" },
                  { value: "10", label: "10" },
                  { value: "25", label: "25" },
                  { value: "50", label: "50" },
                ]}
                onSelect={selectTableCount}
              />
              <Text>Entries</Text>
            </div>

            <div style={{ margin: "0px 50px" }}>
              <Input
                onChange={handleSearchInTable}
                placeholder="Search by Name..."
                style={{
                  width: 400,
                }}
              />
            </div>
            <DownloadTableButtons
              downloadData={rateSetupList}
              columns={columns}
              fileName={"Rate Setup List"}
              onExportClick={getCsvListData}
            />
          </Row>
          <Table
            rowSelection={{
              type: "radio",
              onChange: onSelectItemAction,
            }}
            columns={columns}
            dataSource={rateSetupList}
            bordered
            pagination={{
              position: "bottomCentre",
              pageSize: tableCount,
            }}
          />
        </Spin>
      </Card>
    </MainLayout>
  );
};
const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };

export default connect(mapStateToProps, mapDispatchToProps)(PRD0602);
